import { useState } from 'react';

export const useSelection = () => {
  const [selected, setSelected] = useState<Array<number>>([]);

  return {
    selected,
    isOneSelected: selected.length === 1,
    isSelected: (index: number) =>
      selected.findIndex((item) => item === index) !== -1,
    onSelect: setSelected,
    deselectAll: () => setSelected([]),
  };
};
